(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pw-custom-mockup-product"] && !Shopify.designMode) return;
  try {
    
(()=>{document.querySelectorAll('.pw-cm').forEach(section=>{const hero=section.querySelector('.pw-cm__hero');section.querySelectorAll('[data-pw-cm-thumb]').forEach(button=>button.addEventListener('click',()=>{if(!hero)return;hero.removeAttribute('srcset');hero.removeAttribute('sizes');hero.src=button.dataset.src;hero.alt=button.dataset.alt||'';section.querySelectorAll('[data-pw-cm-thumb]').forEach(item=>{item.classList.toggle('is-active',item===button);item.setAttribute('aria-pressed',item===button?'true':'false')})}))})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pw-s2-cold-traffic"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function enhanceProductForm(){
      var section=document.querySelector('[data-pw-s2-section]');
      var form=document.querySelector('#pw-s2-product-form,product-form,[data-js-product-form]');
      if(!section||!form)return;
      var cta=section.dataset.primaryCta;
      var modelLabel=section.dataset.modelLabel;
      form.querySelectorAll('[data-js-product-add-to-cart-text]').forEach(function(node){if(cta&&node.textContent!==cta)node.textContent=cta;});
      document.querySelectorAll('legend,label,.product-variant__name').forEach(function(node){if(modelLabel&&node.textContent.trim()==='Size')node.textContent=modelLabel;});
      document.querySelectorAll('strong').forEach(function(node){if(node.textContent.trim()==='Please select all pictures at once!'&&node.parentElement)node.parentElement.hidden=true;});
      var select=document.querySelector('select.product-variant-container');
      var selectedOption=select&&select.options[select.selectedIndex];
      var variantId=selectedOption&&selectedOption.getAttribute('data-variant-id');
      var fileInput=document.querySelector('#file-your-label');
      var productFormElement=fileInput&&fileInput.form;
      var variantInput=productFormElement&&productFormElement.querySelector('input[name="id"]');
      if(variantInput&&variantId){variantInput.value=variantId;variantInput.setAttribute('value',variantId);}
      var submit=form.querySelector('button[type="submit"]');
      var modelConfirmation=document.querySelector('[data-pw-s2-model-confirmation]');
      if(submit&&modelConfirmation)submit.disabled=!modelConfirmation.checked;
    }
    enhanceProductForm();
    document.addEventListener('shopify:section:load',enhanceProductForm);
    document.addEventListener('change',function(event){if(event.target.matches('[data-pw-s2-model-confirmation]'))enhanceProductForm();});
    var enhanceTimer;
    new MutationObserver(function(){clearTimeout(enhanceTimer);enhanceTimer=setTimeout(enhanceProductForm,80);}).observe(document.body,{childList:true,subtree:true});
    document.addEventListener('click',function(event){var trigger=event.target.closest('[data-pw-s2-scroll]');if(!trigger)return;var form=document.querySelector('#pw-s2-product-form,product-form,[data-js-product-form]');if(!form)return;form.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});var first=form.querySelector('select,input:not([type="hidden"]),button');if(first)setTimeout(function(){first.focus({preventScroll:true});},500);});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pw-s2-product-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const model = document.querySelector('.pw-s2-hero__form select[name="id"]');
    model?.addEventListener('change', () => {
      const option = model.selectedOptions[0];
      if (!option?.value) return;
      const amount = Number(option.dataset.priceCents);
      const compareAmount = Number(option.dataset.compareCents);
      const onSale = compareAmount > amount;
      const price = document.querySelector('[data-pw-direct-price]');
      const compare = document.querySelector('[data-pw-direct-compare]');
      const discount = document.querySelector('[data-pw-direct-discount]');
      price.textContent = option.dataset.price;
      compare.textContent = onSale ? option.dataset.comparePrice : '';
      compare.hidden = !onSale;
      const percent = onSale ? Math.round((compareAmount - amount) * 100 / compareAmount) : 0;
      discount.textContent = onSale ? (percent > 0 ? `${percent}% off` : 'Sale') : '';
      discount.hidden = !onSale;
      const summary = document.querySelector('[data-pw-direct-summary-price]');
      const sticky = document.querySelector('.pw-s2__sticky strong');
      if (summary) summary.textContent = option.dataset.price;
      if (sticky) sticky.textContent = option.dataset.price;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pw-sprint-2-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.pw-s2');
    sections.forEach((section) => {
      const hero = section.querySelector('.pw-s2__hero');
      section.querySelectorAll('[data-pw-s2-thumb]').forEach((button) => {
        button.addEventListener('click', () => {
          if (!hero) return;
          hero.removeAttribute('srcset');
          hero.removeAttribute('sizes');
          hero.src = button.dataset.src;
          hero.alt = button.dataset.alt || '';
          section.querySelectorAll('[data-pw-s2-thumb]').forEach((item) => {
            item.classList.toggle('is-active', item === button);
            item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
          });
        });
      });

      const form = section.querySelector('.pw-s2__form');
      const model = section.querySelector('select[name="id"]');
      const photo = section.querySelector('input[type="file"]');
      const modelError = section.querySelector('[data-pw-s2-model-error]');
      const photoError = section.querySelector('[data-pw-s2-photo-error]');
      const photoStatus = section.querySelector('[data-pw-s2-file-status]');
      const submit = section.querySelector('[data-pw-s2-submit]');
      const price = section.querySelector('[data-pw-current-price]');
      const comparePrice = section.querySelector('[data-pw-compare-price]');
      const discount = section.querySelector('[data-pw-discount]');

      model?.addEventListener('change', () => {
        if (model.value) modelError.hidden = true;
        const option = model.selectedOptions[0];
        if (!option?.value) return;
        const amount = Number(option.dataset.priceCents);
        const compareAmount = Number(option.dataset.compareCents);
        const onSale = compareAmount > amount;
        price.textContent = option.dataset.price;
        comparePrice.textContent = onSale ? option.dataset.comparePrice : '';
        comparePrice.hidden = !onSale;
        const percent = onSale ? Math.round((compareAmount - amount) * 100 / compareAmount) : 0;
        discount.textContent = onSale ? (percent > 0 ? `${percent}% off` : 'Sale') : '';
        discount.hidden = !onSale;
        const closingPrice = document.querySelector('.pw-s2-policies__live-price');
        if (closingPrice) closingPrice.textContent = option.dataset.price;
      });

      photo?.addEventListener('change', () => {
        const file = photo.files && photo.files[0];
        const valid = file && ['image/jpeg', 'image/png'].includes(file.type);
        if (!file) {
          photoStatus.textContent = 'No photo selected';
          return;
        }
        if (!valid) {
          photo.value = '';
          photoStatus.textContent = 'No photo selected';
          photoError.hidden = false;
          return;
        }
        photoStatus.textContent = `Photo added: ${file.name}`;
        photoError.hidden = true;
      });

      form?.addEventListener('submit', (event) => {
        const modelValid = Boolean(model?.value);
        const file = photo?.files && photo.files[0];
        const photoValid = Boolean(file && ['image/jpeg', 'image/png'].includes(file.type));
        modelError.hidden = modelValid;
        photoError.hidden = photoValid;
        if (!modelValid || !photoValid) {
          event.preventDefault();
          const target = !modelValid ? model : photo;
          target?.focus();
          target?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        submit.disabled = true;
        submit.textContent = submit.dataset.loadingText;
      });

      section.querySelectorAll('[data-pw-s2-scroll]').forEach((button) => {
        button.addEventListener('click', () => {
          form?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          window.setTimeout(() => model?.focus(), 350);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
